import { motion } from "framer-motion";

import { Icon } from "@/atoms/icon/Icon";
import ArrowRight from "@/atoms/icon/icons/arrow_right.svg";
import { ANIMATION_DURATION } from "@/constants/animations.constants";

type ChatRecommendationsProps = {
  readonly recommendations: { id: string; text: string }[];
  readonly onClick: (text: string) => void;
  readonly disabled?: boolean;
};
export default function ChatRecommendations({
  recommendations,
  onClick,
  disabled = false,
}: ChatRecommendationsProps): React.ReactElement {
  return (
    <div className="ChatRecommendations relative z-10 flex min-h-fit flex-col gap-2 ">
      {recommendations.map((recommendation, index) => (
        <ChatRecommendation
          key={recommendation.id}
          onClick={onClick}
          text={recommendation.text}
          disabled={disabled}
          index={index}
        />
      ))}
    </div>
  );
}

type ChatRecommendationProps = {
  readonly onClick: (text: string) => void;
  readonly text: string;
  readonly disabled?: boolean;
  readonly index: number;
};

function ChatRecommendation({
  onClick,
  text,
  disabled = false,
  index,
}: ChatRecommendationProps): React.ReactElement {
  const handleClick = () => {
    if (!disabled) {
      onClick(text);
    }
  };

  return (
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: ANIMATION_DURATION,
        delay: 0.25 + index * 0.1,
      }}
      className={`ChatRecommendation flex items-center justify-center rounded-2xl border border-[#DEC19C] px-6 py-4 transition-colors duration-200 ${
        disabled
          ? "cursor-not-allowed bg-[#f5f5f5] opacity-50"
          : "bg-[#FFF7EC] hover:bg-[#fcfcfc]"
      }`}
      onClick={handleClick}
      disabled={disabled}
    >
      <h1 className="flex-1 text-left text-body1 ">{text}</h1>

      <div>
        <Icon
          svg={ArrowRight}
          size="xsmall"
          color="gold"
          className="ml-2 flex flex-shrink-0 -rotate-90 items-center justify-center rounded-full border border-[#DEC19C]"
        />
      </div>
    </motion.button>
  );
}
